import type {Component} from 'grapesjs';
import type {EmailMakerControl} from '../../right-panel-registry.types';

export type ConditionalControlPredicate = (component: Component, gatingValue: string) => boolean;

export enum ConditionalGatingSource {
  STYLE = 'style',
  ATTRIBUTE = 'attribute',
}

export interface ConditionalControlDescriptor {
  control: EmailMakerControl;
  predicate: ConditionalControlPredicate;
  gatingSource: ConditionalGatingSource;
  gatingKey: string;
}
